import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { ENV_CONFIG } from '@ps/core-config';
import { ApiStatusResponse } from '@ps/utils';
import { OperatorActivityLog, SurveyActivityLog } from '@ps/survey-utils';

import { SurveyActivityLogPayloadMapper } from './mappers/survey-activity-log-payload.mapper';

@Injectable({ providedIn: 'root' })
export class SurveyActivityLogApi {
  private readonly _env = inject(ENV_CONFIG);
  private readonly _http = inject(HttpClient);

  private readonly _baseUrl = this._env.pureSpectrum.url;
  private readonly _mapper = new SurveyActivityLogPayloadMapper();

  public post(log: SurveyActivityLog): Observable<void> {
    return this._http
      .post<ApiStatusResponse>(
        `${this._baseUrl}/activities/v2/surveys/${log.surveyId}`,
        this._mapper.toPayload(log),
      )
      .pipe(map(() => undefined));
  }

  public postOperator(log: OperatorActivityLog): Observable<void> {
    return this._http
      .post<ApiStatusResponse>(
        `${this._baseUrl}/activities/v2/operator`,
        this._mapper.toOperatorPayload(log),
      )
      .pipe(map(() => undefined));
  }
}
